import { useStonlyWidget, usePylonWidget } from 'lib';

/**
 * ScriptLoader component that loads external scripts only when user is authenticated
 * This component uses the useUser hook internally through the script loading hooks
 */
function ScriptLoader() {
  // Load external scripts - hooks will automatically check for user authentication
  // useGoogleMaps();
  useStonlyWidget();
  usePylonWidget();

  // This component doesn't render anything visible
  return null;
}

export default ScriptLoader;
